module.exports = __webpack_public_path__ + "img/09.e9091b61.jpg";